import { useHistory } from "react-router";
import { AzureAuthenticationObject } from "./AzureAuthenticationObject";

/**
 * Redirect to signup with an azure hint (this prefills the form and sends the token passed from azure to the api)
 * @returns {(original: AzureAuthenticationObject, hint: any) => void}
 */
function useHandleAzureSignupHint() {
  const history = useHistory();

  return (original: AzureAuthenticationObject, hint: any) => {
    history.push("/signup", {
      original,
      hint,
      ...Object.fromEntries(new URLSearchParams(history.location.search).entries()),
      marketplace: "azure",
      authMethodKind: "azure",
    });
  };
}

export default useHandleAzureSignupHint;
